export const ActiveDot = () => {
  return (
    <span className="relative flex h-[12px] w-[12px] left-[calc(100%-16px)] top-[-4px] z-10">
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple opacity-75"></span>
      <span className="relative inline-flex rounded-full h-[12px] w-[12px] bg-purple-dark"></span>
    </span>
  );
};
